/* eslint-disable react/prop-types */
import clsx from 'clsx';
import React, { useContext, useEffect, useState } from 'react';
import { PieChart, Pie, Cell } from 'recharts';
import { AppContext } from '../../context/AppContext';
import useWidgetAPI from '../../hooks/network/useWidgetAPI';
import { roundOfAndFormate } from '../../utils/Utils';
import WidgetDropdown from './WidgetDropdown';

function ContractConsumptions({ isSelectedWidget, customerId, projectId, widgetIndex, authToken }) {
  const { getConsumptionsData } = useWidgetAPI();
  const [data, setData] = useState();
  const { widgetDropDownOptions: dropDownOptions } = useContext(AppContext);

  useEffect(() => {
    fetchWidgetData(customerId, projectId);
  }, [customerId, projectId]);

  const fetchWidgetData = async (customerId, projectId) => {
    const query = { customerId, projectId };
    const response = await getConsumptionsData(query);
    setData(response);
  };

  const getTotalTonnage = () =>
    data?.contractDetails?.reduce((acc, s) => {
      acc += s.TOTAL_TONNAGE_MT;
      return acc;
    }, 0);

  const getTotalConsumption = () =>
    data?.tonnageConsumedQuantity?.reduce((acc, s) => {
      acc += s.TonnageConsumed;
      return acc;
    }, 0);

  const getTotalBalance = () => getTotalTonnage() - getTotalConsumption();

  const getGraphData = () => {
    const angle = (getTotalConsumption() / getTotalTonnage()) * 180;

    return [
      { name: 'A', value: angle, color: '#5C920C' },
      { name: 'B', value: 180 - angle, color: '#fff' },
    ];
  };

  const renderWidgetBody = () => {
    return (
      <div>
        <div className='relative mt-4 flex justify-center'>
          <div className='w-[300px] flex-shrink-0 rounded-md border border-blue-400 bg-blue-200'>
            <ContractConsumptionPieChart data={getGraphData()} />
          </div>
          <div className='absolute bottom-2'>
            <p className='font-semibold'>{roundOfAndFormate(getTotalConsumption())} T</p>
          </div>
        </div>
        <div className='mt-4 grid grid-cols-2 gap-x-1'>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900 break:text-sm'># of Contracts</p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {data?.contractDetails?.length}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900 break:text-sm'>
              Total Tonnage (MT)
            </p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {roundOfAndFormate(getTotalTonnage())}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900 break:text-sm'>
              Tonnage Consumed (MT)
            </p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {roundOfAndFormate(getTotalConsumption())}
            </p>
          </div>
          <div className='mb-4'>
            <p className='mb-2 text-xs font-medium text-gray-900 break:text-sm'>
              Balance Consumed (MT)
            </p>
            <p className='truncate text-sm font-semibold break:text-lg'>
              {roundOfAndFormate(getTotalBalance())}
            </p>
          </div>
        </div>
      </div>
    );
  };

  return (
    <div>
      {isSelectedWidget && (
        <div className='rounded-tr-lg rounded-tl-lg border border-solid border-gray-200 bg-[#FFF5EA] py-3 px-3 text-sm font-semibold'>
          {dropDownOptions?.find((f) => f?.customerID === customerId)?.customerName}
        </div>
      )}
      <div
        className={clsx(
          { 'rounded-br-lg rounded-bl-lg': isSelectedWidget },      
          'widget-wrapper',
        )}
      >
        <div className='flex items-start justify-between'>
          <div>
            <p className='text-xs font-semibold text-black break:text-sm'>Contract Consumption</p>
          </div>
          <div className='m-0 self-start p-0 text-[8px]'>
            <span className=''>
              {isSelectedWidget && (
                <WidgetDropdown scope='ContractConsumptions' isSelected widgetIndex={widgetIndex} />
              )}
            </span>
          </div>
        </div>
        {authToken ? (
          <form action='https://prodash.natsteel.com.sg:8080/v1/auth/ump/' method='post'>
            <input type='hidden' name='token' value={authToken} />
            <input type='hidden' name='path' value={'/project-consumption'} />
            <button className='w-full'>{renderWidgetBody()}</button>
          </form>
        ) : (
          renderWidgetBody()
        )}
      </div>
    </div>
  );
}

export default ContractConsumptions;

const cx = 150;
const cy = 120;
const iR = 70;
const oR = 100;

function ContractConsumptionPieChart(props) {
  const { data } = props;
  return (
    <PieChart width={300} height={150}>
      <Pie
        dataKey='value'
        startAngle={180}
        endAngle={0}
        data={data}
        cx={cx}
        cy={cy}
        innerRadius={iR}
        outerRadius={oR}
        fill='#8884d8'
        stroke='none'
      >
        {data.map((entry, index) => (
          <Cell key={`cell-${index}`} fill={entry.color} />
        ))}
      </Pie>
    </PieChart>
  );
}
